import { render, staticRenderFns } from "./MerchantAccountsView.vue?vue&type=template&id=57945da4&scoped=true"
import script from "./MerchantAccountsView.vue?vue&type=script&lang=js"
export * from "./MerchantAccountsView.vue?vue&type=script&lang=js"
import style0 from "./MerchantAccountsView.vue?vue&type=style&index=0&id=57945da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57945da4",
  null
  
)

export default component.exports